<template>
	<sf-data-table
		ref="batchHistoryTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="BatchHistoryCols"
		:rows="rows"	
		:stripe="false"		
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/BatchHistory/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.batchHistoryList;
		},
		BatchHistoryCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('SWCC000204'), // 시간
					prop: 'logDt',
					minWidth: '200px',
					sortable: true
				},					
				{
					label: this.getMessage_('QWCC001125'), // 결과
					prop: 'result',
					minWidth: '140px',
					sortable: true
				},
				{
					label: this.getMessage_('SWCC000206'), // 프로그램 ID
					prop: 'pgmId',
					minWidth: '200px',
					sortable: true
				},				
				{
					label: this.getMessage_('QWCC001537'), // Job 그룹 ID
					prop: 'jobGroupId',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001536'), // Job Id
					prop: 'jobId',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001535'), // Job명
					prop: 'jobNm',
					minWidth: '200px',
					sortable: true					
				},
				{
					label: this.getMessage_('SWCC000210'), // 메세지
					prop: 'message',
					minWidth: '1000px',
					sortable: true					
				}
			];
		}		
	},
	methods: {
		...serviceMethods,		
		resetTable() {
			this.$emit('Refresh');
		},		
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}		
	}
};
</script>

<style></style>
